import { PostError } from '../../Shared/utils/ajax-client';
import { ResetPageReason } from '../payer-onboarding-generated';

export const defaultErrorMessage: string = `Our system encountered an unexpected error. We're currently looking into it. Please try again soon.`;

export type ErrorInfo = {
	error: any;
	message?: string;
	resetPageReason?: ResetPageReason;
};

export function getErrorInfo(e: any): ErrorInfo {
	if (e instanceof PostError && e.validationErrors) {
		return {
			error: e,
			message: `Our system encountered an unexpected error. We're currently looking into it. Please ensure your details are correct.`,
		};
	} else if (e instanceof PostError && e.shouldReloadPage) {
		const resetPageReason = getResetPageReason(e);
		return {
			error: e,
			resetPageReason,
		};
	} else {
		return {
			error: e,
			message: defaultErrorMessage,
		};
	}
}

function getResetPageReason(e: PostError) {
	const isAuthFailure = [401, 403].indexOf(e.client.status) > -1;
	if (isAuthFailure) {
		return ResetPageReason.PersonNotFound;
	}

	const reasonName = e.userError as keyof typeof ResetPageReason;
	const reason: ResetPageReason = ResetPageReason[reasonName] || ResetPageReason.Unknown;
	return reason;
}
